export const THEME_BLUE_BG = "bg-[#f8fbff]";
export const BORDER_SMART = "border-gray-300";

export const toNumber = (value) => {
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : 0;
};

export const formatTax = (value) => {
  const numberValue = toNumber(value);
  return numberValue ? numberValue.toFixed(2) : "0.00";
};

export const hasActiveStatus = (value) => {
  return (
    value === "Y" ||
    value === "y" ||
    value === true ||
    value === "1" ||
    value === 1
  );
};

export const normalizeConfigType = (value = "") => {
  return String(value).trim().toLowerCase();
};

export const normalizeConfigValue = (value = "") => {
  return String(value).trim().toLowerCase();
};

export const getInitialFormData = ({ restaurantName = "" } = {}) => ({
  restaurantName,

  // NEW
  mobileNumber: "",

  restaurantgst: "",
  takeaway: false,
  homeDelivery: false,
  dining: false,
  carOrder: false,
  roomOrder: false,
  restaurantAddress: "",
  restaurantPincode: "",
  posOrder: false,
  settlementAccount: "",
  settlementAccountifsc: "",
});

export const getInitialGstForm = () => ({
  gst: "",
  gstType: "incl",
  taxGst: "",
});

export const getDirectRestaurantRow = (rows = []) => {
  if (!Array.isArray(rows)) return null;
  return rows[0] || null;
};

export const mapRestaurantConfigToForm = (rows = [], prev = {}) => {
  const restaurant = getDirectRestaurantRow(rows);

  if (!restaurant) {
    return { ...prev };
  }

  const configRows = Array.isArray(restaurant.resOrderDetails)
    ? restaurant.resOrderDetails
    : [];

  const next = {
    ...prev,

    restaurantName:
      restaurant.restaurant_name ||
      restaurant.organization_name ||
      prev.restaurantName ||
      "",

    mobileNumber:
      restaurant.restaurant_phone ||
      restaurant.mobile_number ||
      restaurant.mobileNumber ||
      prev.mobileNumber ||
      "",

    restaurantAddress:
      restaurant.street ||
      prev.restaurantAddress ||
      "",

    restaurantPincode:
      restaurant.post_code ||
      prev.restaurantPincode ||
      "",

    restaurantgst:
      restaurant.restaurantgst ||
      restaurant.restaurant_gst ||
      restaurant.gst ||
      prev.restaurantgst ||
      "",

    settlementAccount:
      restaurant.settlement_account ||
      restaurant.settlementAccount ||
      prev.settlementAccount ||
      "",

    settlementAccountifsc:
      restaurant.settlement_account_ifsc ||
      restaurant.settlement_ifsc ||
      restaurant.settlementAccountifsc ||
      prev.settlementAccountifsc ||
      "",

    takeaway: false,
    homeDelivery: false,
    dining: false,
    carOrder: false,
    roomOrder: false,
    posOrder: false,
  };

  configRows.forEach((row) => {
    const type = normalizeConfigType(row?.config_type);
    const value = normalizeConfigValue(row?.config_value);
    const enabled = hasActiveStatus(row?.status);

    if (type !== "order_type") return;

    switch (value) {
      case "takeway":
      case "takeaway":
        next.takeaway = enabled;
        break;

      case "home_delivery":
      case "homedelivery":
      case "delivery":
        next.homeDelivery = enabled;
        break;

      case "dining":
      case "dine_in":
      case "dinein":
        next.dining = enabled;
        break;

      case "car_order":
      case "carorder":
        next.carOrder = enabled;
        break;

      case "room_order":
      case "roomorder":
        next.roomOrder = enabled;
        break;

      case "pos_order":
      case "pos":
        next.posOrder = enabled;
        break;

      default:
        break;
    }
  });

  return next;
};
